export default __webpack_public_path__ + "static/media/IconMagnifyingGlassActive.48b8acf6.svg";